import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const Eyebrow = ({ children, className = "" }) => (
    <span
        className={`font-meta text-[11px] tracking-[0.3em] uppercase text-amber-400/90 inline-flex items-center gap-3 ${className}`}
    >
        <span className="inline-block w-8 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
        {children}
        <span className="inline-block w-8 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
    </span>
);

export const SectionHeading = ({ eyebrow, title, center = false, className = "" }) => (
    <FadeIn className={`${center ? "text-center" : ""} ${className}`}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
            {title}
        </h2>
    </FadeIn>
);
